

















import { Component, Mixins } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'

// components
import NewsForm from '@/components/forms/news/NewsForm.vue'
// mixins
import NotifyMixin from '@/mixins/NotifyMixin'
// store
import AuthModule from '@/store/modules/auth'
import ManagerNewsModule from '@/store/modules/manager/news'
import { NewsDisplayMode, NewsSourceListResource, NewsStoreData } from '@/store/types'
// utils
import { convertDateToMSK } from '@/utils/functions'

@Component({
  components: {
    NewsForm,
  },
})
export default class NewsNew extends Mixins(NotifyMixin) {
  private get isLocalTimezone() {
    return AuthModule.isLocalTimezone
  }

  private form: NewsStoreData = {
    courseIds: [],
    desktopMediaId: undefined as unknown as number,
    displayMode: NewsDisplayMode.DAILY,
    mobileMediaId: undefined as unknown as number,
    mediaIds: [],
    name: '',
    scheduleDates: [],
    text: '',
    url: '',
    viewEndAt: '',
    viewLimit: '' as unknown as number,
    viewStartAt: '',
  }

  private createNews(form: NewsStoreData) {
    const requestForm = {
      ...form,
      desktopMediaId: form.desktopMediaId && (form.desktopMediaId as unknown as number[])[0] || undefined as unknown as number,
      courseIds: form.courseIds.length === 1 && !form.courseIds[0] ? [] : form.courseIds,
      mobileMediaId: form.mobileMediaId && (form.mobileMediaId as unknown as number[])[0] || undefined as unknown as number,
      scheduleDates: form.scheduleDates.map(item => ({ ...item, datetime: convertDateToMSK(item.datetime, this.isLocalTimezone) })),
      viewEndAt: form.viewEndAt ? convertDateToMSK(form.viewEndAt, this.isLocalTimezone) : undefined as unknown as null,
      viewStartAt: form.viewStartAt ? convertDateToMSK(form.viewStartAt, this.isLocalTimezone) : undefined as unknown as null,
    }
    ManagerNewsModule.saveNews(requestForm)
      .then(() => {
        this.notifySuccess('Новость успешно создана.')
        this.$router.push({ name: 'manager.control.news' })
      })
      .catch(this.notifyError)
  }

  private handleCopyLesson(data: NewsSourceListResource) {
    this.form = {
      ...this.form,
      mediaIds: data.media.map(media => media.id),
      name: data.title,
      text: data.text,
    }
  }

  private handleCopyMaterial(data: NewsSourceListResource) {
    this.form = {
      ...this.form,
      mediaIds: data.media.map(media => media.id),
      name: data.title,
      text: JSON.parse(data.text),
    }
  }

  private metaInfo (): MetaInfo {
    return {
      title: 'Создание новости',
    }
  }
}
